/* stylelint-disable */
:host {
  display: block;
  box-sizing: border-box;
  margin-top: 0;
  --qds-control-hero-border-radius: var(--qds-control-border-radius);
  --qds-control-hero-text: var(--qds-control-large-text);
  --qds-control-hero-gap-internal: var(--qds-control-large-gap-internal);
  --qds-control-hero-padding-auto-height: var(--qds-control-large-padding-auto-height);
  --qds-control-button-hero-padding-horizontal: var(--qds-control-button-large-padding-horizontal);
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

.cta-buttons-block {
  --qds-control-hero-border-radius: var(--qds-control-border-radius);
  --qds-control-hero-text: var(--qds-control-large-text);
  --qds-control-hero-gap-internal: var(--qds-control-large-gap-internal);
  --qds-control-hero-padding-auto-height: var(--qds-control-large-padding-auto-height);
  --qds-control-button-hero-padding-horizontal: var(--qds-control-button-large-padding-horizontal);
  display: flex;
  flex-direction: column;
  align-items: left;
  margin: 21px 0 0 0;
}

@media screen and (min-width: 720px) {
  .cta-buttons-block {
    flex-direction: row;
    align-items: center;
  }
}

.cta-links-block {
  --qds-control-hero-border-radius: var(--qds-control-border-radius);
  --qds-control-hero-text: var(--qds-control-standard-text);
  --qds-control-hero-gap-internal: var(--qds-control-standard-gap-internal);
  --qds-control-hero-padding-auto-height: var(--qds-control-standard-padding-auto-height);
  --qds-control-button-hero-padding-horizontal: var(--qds-control-button-standard-padding-horizontal);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 27px;
}

@media screen and (min-width: 720px) {
  .cta-links-block {
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
  }

  :host(:not([dir="rtl"])) .cta-links-block > .cta-element {
    margin: 0 18px 0 0px;
  }

  :host([dir="rtl"]) .cta-links-block > .cta-element {
    margin: 0 0px 0 18px;
  }
}

.cta-section-space {
  margin-top: 29px;
}

.cta-element {
  margin: 0 0 16px;
}

@media screen and (min-width: 720px) {
  :host(:not([dir="rtl"])) .cta-element {
    margin: 0 16px 0 0px;
  }

  :host([dir="rtl"]) .cta-element {
    margin: 0 0px 0 16px;
  }
}

.cta-element:last-child {
  margin: 0;
}

.range-cta-link {
  font-size: 16px;
  line-height: 1.5625;
}

.range-cta-no-margin {
  width: 100%;
  margin: 0;
}

.range-cta-link {
  font-size: 16px;
  line-height: 1.5625;
}

.rangeCtaSec {
  display: flex;
  gap: 8px;
  align-items: center;
  color: #42b4e6;
  cursor: pointer;
}

.cta-software-dropdown-link {
  text-decoration: none;
}

.cta-software-dropdown-button {
  border: none;
  width: 100%;
  background: none;
  font-family: inherit;
  font-size: inherit;
  color: inherit;
  padding: 0;
  margin: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
}

:host(:not([dir="rtl"])) .cta-software-dropdown-button {
  text-align: left;
}

:host([dir="rtl"]) .cta-software-dropdown-button {
  text-align: right;
}

.dropdownLink {
  text-decoration: none;
}

.dropdown .rangeCtaSec {
  color: #333333;
}

:host(:not([dir="rtl"])) .dropdown .cta-element {
  padding-left: 15px;
}

:host([dir="rtl"]) .dropdown .cta-element {
  padding-right: 15px;
}

@media screen and (max-width: 979px) {
  .dropdown .cta-element {
    margin-bottom: 0px;
  }

  :host(:not([dir="rtl"])) .dropdown .cta-element {
    padding-left: 12px;
  }

  :host([dir="rtl"]) .dropdown .cta-element {
    padding-right: 12px;
  }
}

.dropdown .dropdown-cta {
  height: 27px;
}

@media screen and (max-width: 979px) {
  .dropdown .dropdown-cta {
    margin-bottom: 0px;
  }

  :host(:not([dir="rtl"])) .dropdown .dropdown-cta {
    padding-left: 19px;
  }

  :host([dir="rtl"]) .dropdown .dropdown-cta {
    padding-right: 19px;
  }
}

.cta-dropdown {
  display: inline-block;
  box-sizing: unset;
}

.product-selector-cta-link:hover {
  margin-bottom: 2px;
  text-decoration: underline;
  text-underline-position: from-font;
}

:host(:not([dir="rtl"])) .product-selector-cta-icon {
  margin-left: 4px;
}

:host([dir="rtl"]) .product-selector-cta-icon {
  margin-right: 4px;
}